import {
    GetDatepickerTranslationAction,
    SetDatepickerTranslationAction,
} from "../../interfaces/store/actions/antdTranslation";
import {GET_DATEPICKER_TRANSLATION, SET_DATEPICKER_TRANSLATION} from "../actions/antdTranslation";
import {AntdTranslationState} from "../../interfaces/store/reducers/antdTranslationState";

const initialState: AntdTranslationState = {
    datepicker: null,
};

type AvailableActions = GetDatepickerTranslationAction
| SetDatepickerTranslationAction;

const antdTranslationReducer = (state = initialState, action: AvailableActions): AntdTranslationState => {
    switch (action.type) {
        case GET_DATEPICKER_TRANSLATION:
            return state;
        case SET_DATEPICKER_TRANSLATION:
            return {
                ...state,
                datepicker: action.payload,
            };
        default:
            return state;
    }
};
export default antdTranslationReducer;
